module.exports = __webpack_public_path__ + "img/core_01.7a3d9716.png";